<script setup>
  import { ref, onMounted } from 'vue';
  import { useGoogleMapsStore } from '@/stores/GoogleMapsStore';
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const model = defineModel();
  const viewType = defineModel('viewType');

  const googleMapsStore = useGoogleMapsStore();

  const { windbow } = useLegacyBridge();

  const contentContainer = ref(null);
  const modelSelectorContainer = ref(null);  
  
  function loadWindbow() {
    const settings = {
      modelSelectorTarget: modelSelectorContainer.value,
      viewType: viewType.value,
      showViewTypeControl: false,
      showChartTimeframeControl: false,
    }
    
    model.value = windbow(contentContainer.value, settings);
  }

  onMounted(() => {
    googleMapsStore.loadMaps(loadWindbow);
  })  
</script>

<template>
  <div
    class="jwx-data-container__scrolling-submenus jw-model-selector-container"
    ref="modelSelectorContainer"
  ></div>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>